/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { COLORS } from "./plans.constants";
import usePlans from "./usePlans";
import PlanCard from "./PlanCard";
import "./PlansSection.css";

export default function PlansSection() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === "ar";

  const { plans, loading } = usePlans(isArabic);

  return (
    <section
      id="plans-section"
      style={{
        direction: isArabic ? "rtl" : "ltr",
        background: COLORS.gradient,
        color: COLORS.textLight,
        padding: "100px 0 80px",
        minHeight: "100vh",
      }}
    >
      <ToastContainer position="top-center" autoClose={3000} rtl={isArabic} />

      <div className="container text-center">
        <h2 className="mb-5" style={{ color: COLORS.gold }}>
          {isArabic ? "اختر خطتك المثالية" : "Choose Your Ideal Plan"}
        </h2>

        {loading ? (
          <p style={{ fontSize: "1.3rem" }}>
            {isArabic ? "جارِ تحميل الباقات..." : "Loading plans..."}
          </p>
        ) : plans.length === 0 ? (
          <p style={{ fontSize: "1.4rem" }}>
            {isArabic
              ? "لا توجد باقات متاحة حالياً"
              : "No plans available at the moment"}
          </p>
        ) : (
          <div className="row justify-content-center g-4 g-lg-5">
            {plans.map((plan) => (
              <PlanCard key={plan.id} plan={plan} isArabic={isArabic} />
            ))}
          </div>
        )}

        <div
          style={{
            height: "4px",
            width: "120px",
            background: COLORS.gold,
            margin: "60px auto 0",
          }}
        />
      </div>
    </section>
  );
}
